// Import 3rd party libraries
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let hasRun = false;

let isHeadlineExposed = () => {
    return window.scrollY > window.innerHeight / 2;
}

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isTablet: "max-width: 991px",
        isLandscape: "(orientation: landscape)",
        isPortrait: "(orientation: portrait)",
    };
    
    gsap.matchMedia().add(matches, (context) => {
        let container = "hero--video-container";
        let svg = "hero-text-svg";
        let isMobile = context.conditions.isMobile;
        let isPortrait = context.conditions.isPortrait;
        let isLandscape = context.conditions.isLandscape;
        let heroLoadTimeline = gsap.timeline();

        let onScroll = () => {
            if (isHeadlineExposed()) {
                cleanup();
            }
        }

        window.addEventListener("scroll", onScroll);

        /**
         * Clean up after the animation is complete
         *
         * This animation should only run once per page load, completely
         * remove the timeline from memory and set a flag to
         * prevent it from running again.
         */
        let cleanup = () => {
            // The loaded class is used to set the width and height of the
            // video container to 100% in the CSS. Initially, the container
            // is set to `100% - 2px` to properly clip the svg mask.
            const videoWrapper = document.getElementById(`${container}`);
            videoWrapper.classList.add("loaded");

            // Due to FUK, when motion is allowed we initially set the masthead opacity to 0
            // We need to change the opacity back to 1, because when the animation is complete, the
            // style from the animation that shows the masthead will be removed on cleanup. We do this
            // by setting a class that will prevent the opacity from getting set in the stylesheet.
            const masthead = document.getElementById("masthead");
            masthead.classList.add("loaded");

            // Remove the timeline from memory
            heroLoadTimeline.revert();
            heroLoadTimeline.clear();
            heroLoadTimeline.kill();

            // Set the flag to prevent the timeline from running again
            hasRun = true;

            // Remove the event listener
            window.removeEventListener("scroll", onScroll);
        }

        if (!hasRun && !isHeadlineExposed()) {
            /**
             * Handle the FUK
             * 
             * The video container is set to an opacity of 0 in the CSS
             * to prevent the video from flashing before the animation.
             * This will expose the video container before the animation.
             */
            heroLoadTimeline.to(`#${container}`, {opacity: 1,duration: .1,});
            heroLoadTimeline.from("#hero .hero-text-svg", {fontSize: "20.5rem", duration:.1});
        
            
            /**
             * Zoom in the video container
             */
            heroLoadTimeline.from(`#${container}`, 
                {
                    height: isPortrait ? "50vw" : "28.125vw",
                    width: "50vw",
                    top: "unset",
                    left: "unset",
                    right: "unset",
                    bottom: "unset",
                    duration: 1.75,
                }
            );

            /**
             * Fade out the SVG mask
             */
            if (isLandscape) {
                heroLoadTimeline.from(`#${container} .${svg}`, 
                    {
                        opacity: 1,
                        duration: 1,
                    }, 
                    "-=40%"
                );
            }


            /**
             * Fade in the headline
             */
            heroLoadTimeline.fromTo("#headline h1", 
                {opacity: 0}, 
                {
                    opacity: 1, 
                    duration: 1, 
                    ease: "power2.inOut"
                }, 
                "+=.2"
            );

            // Fade in the navigation
            heroLoadTimeline.fromTo("#masthead",
            {
                    autoAlpha: 0,
                    y: -120
                },
                {
                    autoAlpha: 1,
                    duration: .5,
                    ease: "power2.inOut"
                },
                "-=1"
            );

            heroLoadTimeline.eventCallback("onComplete", cleanup);
        }
        else {
            cleanup();
        }
    });
}